import { css } from 'react-emotion';
import { fontFamily, colors } from '../../variables';

const typeToColor = (type?: string) => {
  if (!type) {
    return colors.dark;
  }
  type = type.toLowerCase();
  switch (type) {
    case 'title':
      return colors.dark;
    case 'link':
      return colors.action;
    case 'error':
      return colors.bad;
    case 'subtitle':
      return colors.gray;
    default:
      return colors.dark;
  }
};

export namespace styles {
  export const label = (type?: string, large: boolean = false) =>
    css({
      fontFamily,
      fontWeight: type === 'title' ? 600 : 'normal',
      fontSize: large ? '1.5rem' : '1.3rem',
      lineHeight: '1.46',
      letterSpacing: '0.2px',
      display: 'block',
      textDecoration: 'none',
      margin: '4px 0',
      color: typeToColor(type),
      ' + .input-group': {
        marginTop: 12
      }
    });
}
